import { render, staticRenderFns } from "./CreateForm.vue?vue&type=template&id=7bfd8f38&scoped=true"
import script from "./CreateForm.vue?vue&type=script&lang=js"
export * from "./CreateForm.vue?vue&type=script&lang=js"
import style0 from "./CreateForm.vue?vue&type=style&index=0&id=7bfd8f38&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bfd8f38",
  null
  
)

export default component.exports